<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
}
</script>

<style lang="less">
  @scene_bg_color: #000B41;

  @font-face {
    font-family: 'Myriad Pro';
    src: local('Myriad Pro SemiExt'), local('MyriadPro-SemiExt'), url('../../static/fonts/MyriadPro-SemiExt.woff') format('woff');
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: 'Myriad Pro';
    src: local('Myriad Pro SemiboldSemiExt'), local('MyriadPro-SemiboldSemiExt'), url('../../static/fonts/MyriadPro-SemiboldSemiExt.woff') format('woff');
    font-weight: bold;
    font-style: normal;
  }
  @font-face {
    font-family: 'Myriad Pro';
    src: local('Myriad Pro LightSemiExt'), local('MyriadPro-LightSemiExt'), url('../../static/fonts/MyriadPro-LightSemiExt.woff') format('woff');
    font-weight: 300;
    font-style: normal;
  }
  @font-face {
    font-family: 'Myriad Pro';
    src: local('Myriad Pro Condensed'), local('MyriadPro-Cond'), url('../../static/fonts/MyriadPro-Cond.woff') format('woff');
    font-weight: 300;
    font-style: normal;
    font-stretch: condensed;
  }
  @font-face {
    font-family: 'Myriad Pro';
    src: local('Myriad Pro Bold Condensed'), local('MyriadPro-BoldCond'), url('../../static/fonts/MyriadPro-BoldCond.woff') format('woff');
    font-weight: bold;
    font-style: normal;
    font-stretch: condensed;
  }

  html {
    width: 100%;
    height: 100%;
    background: @scene_bg_color;
    text-rendering: optimizeLegibility;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-smoothing: antialiased;
  }

  body {
    margin: 0;
    font-family: 'Myriad Pro', sans-serif;
    background-color: @scene_bg_color;
    &.fixed {
      overflow: hidden;
    }
  }

  #app {
  }
</style>



// WEBPACK FOOTER //
// src/App.vue